<template>
    <div v-show="isLoading" class="blockUI blockMsg blockElement loading-parent-div">
        <div class="loader">
        </div>
        <div class="message">Loading...</div>
    </div>
</template>
  
<script>

export default {
    name: 'audienceLoader',
    props: ['isLoading'],
    data() {
      return {};
    },
};
</script>
  
<style lang="scss">

.loading-parent-div{
    z-index: 1011; 
    position: absolute; 
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 8rem;
}
</style>
